module.exports = __webpack_public_path__ + "img/Foggs-Around-the-World.e8b22a64.jpg";